import React from "react";
import { Box, Group, Drawer, Button, SegmentedControl, Text, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";

const SupplierFilter = ({
    stateShow,
    fnShow,
    stateDefaultFilter,
    stateFilter,
    fnFilter
}) => {

    const [data, setData] = React.useState({
        filterIsActive: stateFilter.filterSupplierIsActive,
    });

    const handleFilter = () => {
        fnFilter(
            data.filterIsActive,
        )
    }

    const handleReset = () => {
        setData(d => ({
            ...d,
            filterIsActive: stateDefaultFilter.supplierIsActive,
        }))
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Filter Supplier</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel="Status"
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.filterIsActive}
                                onChange={(val) => setData(d => ({ ...d, filterIsActive: val }))}
                                data={[
                                    { label: 'Semua', value: utils.flagAll },
                                    { label: 'Aktif', value: '1' },
                                    { label: 'Non Aktif', value: '0' },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={handleReset}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            color='teal'
                            onClick={handleFilter}
                        >
                            Filter
                        </Button>
                    </Group>
                </Box>
            </Drawer>
        </React.Fragment>
    )
}

export default SupplierFilter;